<template>
	<div class="template contact select" v-show="dataVal.IsShow || dataVal.IsShow == null">
		<div class="panel_wrap">
			<label class="panel_title">{{ dataVal.Property.Title[0].Text }}<span v-show="dataVal.Property.Require == 1"
					class="require">*</span>
			</label>

			<div class="input_value"
				v-if='dataVal.filterable == undefined || dataVal.filterable == null || dataVal.filterable == false'
				:style="dataVal.Property.Title[0].Text.length == 4 ? 'max-width:calc(100% - 67px);' : ''">
				<Select v-if='dataVal.Config.Selector.Type == "multi"' v-bind:disabled="dataVal.Disable"
					:max-tag-count="6" :transfer='true' v-model="dataVal.ValuesSelect" @on-focus="closeReadOnly"
					@on-hook:mounted="closeReadOnly" @on-visible-change="closeReadOnly"
					@on-change="changeVal(dataVal.Property.Title[0].Text, dataVal.Config.Selector.Type)" multiple>
					<Option v-for="item in dataVal.Config.Selector.Options" :value="item.Key" :key="item.Key"
						v-show="item.IsShow == null || item.IsShow">{{ item.Value[0].Text }}</Option>
				</Select>
				<Select v-if='dataVal.Config.Selector.Type == "single"' v-bind:disabled="dataVal.Disable"
					v-model="dataVal.Value"
					@on-change="changeVal(dataVal.Property.Title[0].Text, dataVal.Config.Selector.Type)">
					<!-- <Option :disabled="item.IsShow!=null&&!item.IsShow"  v-for="item in dataVal.Config.Selector.Options" :value="item.Key" :key="item.Key">{{ item.Value[0].Text}}</Option> -->
					<Option v-for="item in dataVal.Config.Selector.Options" :value="item.Key" :key="item.Key">{{
						item.Value[0].Text }}</Option>
				</Select>
			</div>
			<div class="input_value select001" v-if='dataVal.filterable == true'
				:style="dataVal.Property.Title[0].Text.length == 4 ? 'max-width:calc(100% - 67px);' : ''">
				<!--				<Select filterable remote :label-in-value="true" clearable @on-clear='clearSelect' :remote-method="remoteMethod" v-model="dataVal.Value" v-loadmore="loadMore"-->
				<!--				 @on-change="selectChange" v-bind:disabled="dataVal.Disable" :placeholder="dataVal.Property.Placeholder[0].Text==''?'请选择':dataVal.Property.Placeholder[0].Text ">-->
				<!--					<Option v-for="item in dataVal.Options" :value="item.Key" :key="item.Key">{{ item.Value}}</Option>-->
				<!--				</Select>-->
				<el-select ref="selectEstate" filterable remote clearable @clear="clearSelect"
					:remote-method="remoteMethod" v-model="dataVal.value" @change="selectChange"
					:disabled="dataVal.Disable" @hook:mounted="cancalReadOnly" @visible-change="cancalReadOnly"
					:placeholder="dataVal.Property.Placeholder[0].Text == '' ? '请选择' : dataVal.Property.Placeholder[0].Text"
					value-key="Key" size="mini">
					<el-option v-for="item in dataVal.Options" :key="item.Key" :label="item.Value" :value="item">
					</el-option>
				</el-select>
			</div>


			<!-- <div class="input_value" v-if='dataVal.filterable==true' :style="dataVal.Property.Title[0].Text.length == 4?'max-width:calc(100% - 67px);':''">
							<Select filterable remote  :loading="loading" :remote-method="remoteMethod" v-loadmore="loadMore"
							 v-bind:disabled="dataVal.Disable" v-model="dataVal.Value" :placeholder="dataVal.Property.Placeholder[0].Text==''?'请选择':dataVal.Property.Placeholder[0].Text ">
								<Option v-for="item in dataVal.Options" :value="item.Key" :key="item.Key">{{ item.Value}}</Option>
							</Select>
						</div> -->
		</div>
		<div class="select-value" v-if="dataVal.Property.Title[0].Text == '出差人员'">
			<div class="item" v-for="(item, index) in datas" :key='index'>{{ item }}<div class="img"
					@click="deleteData(item)"></div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	getDepartmentList
} from '@/api/department'

import {
	getEmpInfo
} from '@/api/employee'
import {
	findExtates
} from '@/api/nuisanceDisk'
import {
	getAllocationTemplatePagers,
	getEmployee
} from '@/api/allocation'
export default {
	props: ['dataVal'],
	data() {
		return {
			page: 1,
			size: 10,
			totalPage: 1,
			querys: null,
			loading: false,
			select: '',
			datas: [],
			seComData: {
				TemplateName: ""
			},
			dept: new Map()
		}
	},
	mounted() {
	},
	created() {

	},
	methods: {
		closeReadOnly(val) {
			// this.$nextTick(() => {
			//   if (!val) {
			//     const input = this.$refs.search.$el.querySelector('.el-input__inner')
			//     const timer = setTimeout(() => {
			//       input.removeAttribute('readonly')
			//       clearTimeout(timer)
			//     }, 200)
			//   }
			// })
		},
		changeVal(name, type) {
			var val = null;
			if (type == "multi") {
				val = this.dataVal.ValuesSelect
				this.dataVal.Values = [];
				this.dataVal.ValuesSelect.forEach(item => {
					this.dataVal.Values.push([item]);
				});
			} else {
				val = this.dataVal.Value
			}
			this.$emit('child-event', val, name, type, this.dataVal);
		},
		loadMore() {
			this.page++;
			if (this.page > this.totalPage) {
				return;
			}
			this.remoteMethod(this.querys);
		},
		cancalReadOnly(onOff) {
			this.$nextTick(() => {
				if (!onOff) {
					const {
						selectEstate,
					} = this.$refs;
					const input = selectEstate.$el.querySelector('.el-input__inner');
					input.removeAttribute('readonly');
				}
			});
		},
		selectChange(item) {
			item = {
				label: item.Value,
				value: item.Key
			}
			this.dataVal.Value = item.label;
			var that = this;
			if (item != null) {
				this.select = item.label;
				if (that.dataVal.Property.Title[0].Text == '出差人员') {
					if (that.datas.indexOf(item.label) == -1) {
						that.datas.push(item.label);
					}
					if (!that.dataVal.Values) {
						that.dataVal.Values = [item.label]
					} else {
						if (that.dataVal.Values.indexOf(item.label) == -1) {
							that.dataVal.Values.push(item.label)
						}
					}
					that.dataVal.Value = "请选择"
				} else if (that.dataVal.Property.Title[0].Text == '分佣比例类型') {
					if (that.dataVal.IsSeComChange === undefined || that.dataVal.IsSeComChange !== true) {
						that.seComSelector(item, "secom");
					} else {
						that.seComSelector(item, "secomNul");
					}
				}
				if (that.dataVal.Property.Title[0].Text == '员工工号' && that.dataVal.tag != undefined) {
					this.querys = item.value;
					that.seComSelector(item, "seno");
				}
				if (
					that.dataVal.Property.Title[0].Text == "部门数据填写人" &&
					that.dataVal.IsDeptPer == true
				) {
					that.seComSelector(that.dept, "exhibit");
				}
				if (that.dataVal.Property.Title[0].Text == "楼盘名称" && that.dataVal.housename == true) {
					that.seComSelector(item, "housename")
				}
			}
		},
		seComSelector(val, type) {
			this.$emit("child-event", val, type, this.dataVal)
		},
		deleteData(val) {
			for (var i = 0; i < this.datas.length; i++) {
				if (val == this.datas[i]) {
					this.datas.splice(i, 1);
					this.dataVal.Values.splice(i, 1);
					return;
				}
			}
		},
		clearSelect() {
			var that = this;
			if (that.dataVal.tag == "emp") {
				that.seComSelector('', "clearEmp")
			}
		},
		remoteMethod: async function (query) {
			if (this.dataVal.IsSeComChange !== null && this.dataVal.IsSeComChange === true) {

				return;
			}
			if ((this.dataVal.housename === null || this.dataVal.housename === undefined) || (this.dataVal.houseunit === null || this.dataVal.houseunit === undefined)) {
				if (query == null || query == '' || query.indexOf("(") > 0 || query.indexOf(")") > 0) {
					this.dataVal.Options = [];
					this.dataVal.Value = '';
					return;
				}
			} else {
				if (query == null || query == '') {
					this.dataVal.Options = [];
					this.dataVal.Value = '';
					return;
				}
			}
			if (this.select == query) {
				return
			}
			if (this.dataVal.houseunit != null && this.dataVal.houseunit === true) {
				return
			}
			if (query !== this.querys) {
				this.page = 1;
				this.$set(this.dataVal, 'Options', []);
			}
			if (query == null || query.length <= 0) {
				return;
			}
			this.querys = query;
			if (this.dataVal.IsEmp != null && this.dataVal.IsEmp == true) {
				this.dataVal.Options = [];
				await getEmpInfo(query, this.page).then(res => {
					if (res.Body != null) {
						res.Body.forEach(item => {
							var data = {
								"Key": item.EmpName + "(" + item.JobLevel + "级)",
								"Value": item.EmpName + "(" + item.JobLevel + "级)"
							};
							this.dataVal.Options.push(data);

						});
					}
					// this.loading = false;
					this.totalPage = res.TotalPagers;
				})
			} else if (this.dataVal.IsEmpAndPer != null && this.dataVal.IsEmpAndPer == true) {
				let keys = [];
				let VirtualEmps = ["A957-楼价公共", "A956-策略员工", "A966-策划公共", "A988-拓展公佣", "ASCH01-三岔湖甲方侯陈甦颖"];
				this.dataVal.Options = [];
				if (query != "" || query != null) {
					await getEmployee(query).then(res => {
						let bodys = res.body;
						if (bodys != null && bodys.length > 0) {
							this.dataVal.Options = [];
							bodys.forEach((item) => {
								if (!keys.includes(item.empNo)) {
									// this.dataVal.Options.push({"Key":item.empNo,"Value":`${item.empNo}-${item.empName}`});
									// this.dataVal.Options.push({"Key":`${item.empNo}-${item.empName}`,"Value":item.empNo});
									this.dataVal.Options.push({ "Key": `${item.empNo}-${item.empName}`, "Value": `${item.empNo}-${item.empName}` });
									keys.push(item.empNo);
								}
							})
						}
					})
					VirtualEmps.forEach(item => this.dataVal.Options.push({ "Key": item, "Value": item }))
				}
				this.dataVal.tag = "emp";
			} else if (this.dataVal.IsSeCom != null && this.dataVal.IsSeCom == true) {
				this.seComData.TemplateName = query;
				this.dataVal.Options = [];
				let keys = [];

				if (query != "" || query != null) {
					//模糊查询分佣比例模板
					await getAllocationTemplatePagers(this.seComData).then(res => {
						let bodys = res.body;
						if (bodys != null) {
							this.dataVal.Options = [];
							bodys.forEach((item) => {
								if (!keys.includes(item.key)) {
									this.dataVal.Options.push({ "Key": item.key, "Value": item.value1 })
									keys.push(item.key)
								}
							})
						}
					})
				}
			} else if (this.dataVal.housename != null && this.dataVal.housename == true) {
				if (((query.split('-')).length - 1) >= 3) {
					return
				}
				let config = {
					Selector: {
						Options: []
					}
				}
				// this.$set("this.dataVal","Config",config)
				await findExtates(query).then(res => {
					let bodys = res.Body;
					let datas = null;
					if (bodys != null && bodys.length > 0) {
						this.$set(this.dataVal, "Options", [])
						for (let i = 0; i < bodys.length; i++) {
							this.dataVal.Options.push({ "Key": bodys[i].EstateKeyId, "Value": bodys[i].EstateName })
						}
						// this.dataVal.Config={
						//   Selector: option
						// }
					}
				})
			} else if (this.dataVal.IsDeptPer != null && this.dataVal.IsDeptPer == true) {
				this.dataVal.Options = [];
				let map = new Map();
				var data = null;
				//部门条件
				await getEmployee(query).then(emp => {
					data = emp;
				})
				//模糊查询营运部门数据填写人
				if (data != null) {
					let bodys = data.body;
					if (bodys != null && bodys.length > 0) {
						this.dataVal.Options = [];
						this.dept.clear();
						bodys.forEach((item) => {
							this.dataVal.Options.push({ "Key": item.empNo, "Value": `${item.empNo}-${item.empName}` });
							if (item.deptFullName != undefined) {
								let deptName = item.deptFullName.split("/");
								if (this.dept.get(item.empNo) == undefined) {
									this.dept.set(item.empNo, deptName[deptName.length - 1])
								}
							}
						})
					}
				}
			} else {
				this.dataVal.Options = [];
				// this.loading = true;
				await getDepartmentList(query, this.page).then(res => {
					res.Body.Items.forEach(item => {
						var data = {
							"Key": item.PositionId + "|" + item.PositionName,
							"Value": item.PositionName
						};
						this.dataVal.Options.push(data);
					});
					// this.loading = false;
					this.totalPage = res.Body.TotalPage;
				});
			}

		}
	}

}
</script>

<style lang="less">
@import '../assets/css/common.css';

.ivu-select-selection {
	border: none !important;
}

.ivu-select-single .ivu-select-selection {
	height: 24px !important;
}

.ivu-select-single .ivu-select-selection .ivu-select-placeholder,
.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
	height: 24px !important;
	line-height: 24px !important;
}

.ivu-select-single .ivu-select-input {
	height: 24px !important;
	line-height: 24px !important;
}

.ivu-select-dropdown-list {
	text-align: left !important;
	opacity: 1
}

.select .input_value {
	height: auto !important;
	line-height: 24px !important;
}

.ivu-select-multiple .ivu-tag {
	max-width: 98% !important;
	overflow: hidden !important;
	white-space: nowrap !important;
	text-overflow: ellipsis !important;
}

.select-value {
	width: 100%;
	overflow: hidden;

	.item {
		float: left;
		position: relative;
		padding: 4px 15px;

		.img {
			display: inline-block;
			background: url(../assets/image/icons.png);
			background-position: -747px -106px;
			width: 10px;
			height: 10px;
			position: absolute;
			top: 0;
			right: 6px;

		}
	}
}
</style>
